/* ============
 * Mutations for the event module
 * ============
 *
 * The mutations that are available on the
 * user module.
 */

export default {
  setJWT (state, payload) {
    state.jwt = payload
  },
  setExp (state, payload) {
    state.exp = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/event/mutations.js